import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { MyRoleAssignments } from '../../components/me/MyRoleAssignments';
import { UpdateProfileForm } from '../../components/me/UpdateProfileForm';
import { MfaPreferenceForm } from '../../components/me/MfaPreferenceForm';
import { ChangePasswordForm } from '../../components/me/ChangePasswordForm';
import { SecondaryIdentifierSwitch } from '../../components/me/SecondaryIdentifierSwitch';
import { useMyTenantIdentifier } from '../../hooks/useMyTenantIdentifier';
import { Card, Button } from '@fiado/react-kit';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from '../../components/ui/dialog';

function ProfilePage() {
    const [pwdOpen, setPwdOpen] = useState(false);
    // DEC-RBAC-045: ocultar la tarjeta de MFA si el tenant tiene el 2FA apagado (mfaEnabled === false).
    // `undefined` (platform o backend sin el campo) ⇒ se muestra por default.
    const { mfaEnabled } = useMyTenantIdentifier();
    const showMfa = mfaEnabled !== false;

    return (
        <div className="mx-auto max-w-5xl space-y-6">
            {/* Fila superior: perfil + MFA lado a lado (evita scroll en pantallas normales). */}
            <div className="grid gap-6 lg:grid-cols-2">
                <Card title="Mi perfil">
                    <UpdateProfileForm />
                    <div className="mt-5 border-t border-border pt-4">
                        <Button
                            variant="secondary"
                            onClick={() => {
                                setPwdOpen(true);
                            }}
                        >
                            Cambiar contraseña
                        </Button>
                    </div>
                </Card>

                {showMfa && (
                    <Card title="Método de verificación (MFA)">
                        <MfaPreferenceForm />
                    </Card>
                )}
            </div>

            {/* DEC-RBAC-081: agregar+verificar el identificador secundario (login dual). Solo se
                muestra si el tenant lo permite; trae su propia Card (full-width como las otras). */}
            <SecondaryIdentifierSwitch />

            <Card title="Mis roles">
                <MyRoleAssignments />
            </Card>

            {/* Cambio de contraseña en modal (antes ocupaba una tarjeta grande en la página). */}
            <Dialog open={pwdOpen} onOpenChange={setPwdOpen}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Cambiar contraseña</DialogTitle>
                        <DialogDescription>
                            Ingresa tu contraseña actual y la nueva.
                        </DialogDescription>
                    </DialogHeader>
                    <ChangePasswordForm
                        onDone={() => {
                            setPwdOpen(false);
                        }}
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
}

export const Route = createFileRoute('/_authenticated/_layout/me/profile')({
    component: ProfilePage,
});
